// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg-light{
  background-color: rgb(255 255 255) !important;
 }

.navbar-brand img {
  width: 150px;
  height: auto;
  margin: auto;
}

.search-form-container {
  position: relative; /* For positioning the search overlay relative to this container */
}

.search-button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 10px;
  font-size: 20px;
}

.search-overlay {
  position: absolute;
  top: 0;
  right: 47px;
  padding: 0;
  border-radius: 5px;
  display: flex
;
  align-items: center;
  z-index: 1000;
}

.search-input {
  background-color: #fff;
  color: #000;
  border-radius: 5px;
  border: 1px solid #ccc;
  padding: 8px;
  width: 500px;
  transition: width 0.3s ease;
}

.search-input:focus {
  outline: none;
  border-color: #007bff;
}

.search-overlay .search-input {
  width: 500px; 
}

.search-overlay.show {
  opacity: 1;
  visibility: visible;
}


.nav-link {
  color: #000!important;
}

.search-button,
button {
  border: none;
  background: none;
  font-size: 14px;
  cursor: pointer;
  padding: 10px 0;
  margin-left: 10px;
  display: flex;
  align-items: center;
  font-weight: 600;
}

.dropdown-item {
  color: black;
  font-size: 12px;
  font-weight: bold; /* Makes the font bold */
  padding: 8px 8px;
}

.dropdown-item:hover {
  background: lightgray; /* Changes background color on hover */
  color: blue; /* Changes text color on hover */
  cursor: pointer; /* Shows a pointer cursor on hover */
}

.search-button svg {
  color: #7f7f7f;
  font-size: 16px;
}

button a {
  text-decoration: none;
  color: #000;
  display: flex;
  align-items: center;
}

button a svg {
  margin-right: 5px;
}

button:hover a {
  color: white;
  text-decoration: none;

}

.navbar-nav {
  font-weight: 600;
  font-size: 12px;
  gap: 0;
}

button {
  border: 1px solid #2067d1;
  border-radius: 10px;
  background-color: #2067d1;
  color: #fff;
  padding: 8px 12px;
  transition: all 0.3s ease;
}

.phoneButton{
  border-radius: 10px;
}

button a {
  color: #fff;
  font-weight: 600;
}

@media (width <= 768px) {
  .phoneButton{
    display: none;
  }

  .search-overlay{
    right: 14px;
  }

  .search-overlay .search-input {
    width: 336px;
}

  .navbar {
    padding: 0.5rem;
  }

  .logo-img {
    height: 40px;
  }

  .nav-link {
    font-size: 14px;
    margin-right: 10px;
    padding: 11px 5px !important;
    border-bottom: 1px solid #c5c5c5;

  }

  .search-form-container{
  position: relative;
    border-bottom: 1px solid #c5c5c5;
  }

  button {
    font-size: 12px;
    padding: 5px 8px;
    width: 50px;

  }

  button a {
    font-size: 12px;
  }
}
.ms-auto {
  margin-left: 28px !important;
}

.custom-navbar {
  transition: all 0.3s ease-in-out;
  width: 100%;
  z-index: 1000;
}

.custom-navbar.sticky {
  position: fixed;
  top: 0;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.95); /* Slight transparency */
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}

.logo-img {
  max-height: 60px;
}

/* Search Box */
.search-form-container {
  position: relative;
}

.search-button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
}

.search-overlay {
  position: absolute;
  right: 0;
  top: 40px;
  background: white;
  border-radius: 5px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  padding: 10px;
}

.search-input {
  width: 200px;
  padding: 5px;
}

/* Phone Button */
.phoneButton {
  background-color: #007bff;
  border: none;
  padding: 8px 15px;
  border-radius: 5px;
  color: white;
  font-size: 14px;
  cursor: pointer;
  margin-left: 10px;
}

.phoneButton a {
  color: white;
  text-decoration: none;
}

.phoneButton:hover {
  background-color: #0056b3;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/styles/css/header.css"],"names":[],"mappings":"AAAA;EACE,6CAA6C;CAC9C;;AAED;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB,EAAE,kEAAkE;AACxF;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB;AACF;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;;AAGA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB,EAAE,wBAAwB;EAC3C,gBAAgB;AAClB;;AAEA;EACE,qBAAqB,EAAE,sCAAsC;EAC7D,WAAW,EAAE,gCAAgC;EAC7C,eAAe,EAAE,oCAAoC;AACvD;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,qBAAqB;;AAEvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,MAAM;AACR;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;AAChB;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,4BAA4B;IAC5B,gCAAgC;;EAElC;;EAEA;EACA,kBAAkB;IAChB,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;;EAEb;;EAEA;IACE,eAAe;EACjB;AACF;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,WAAW;EACX,aAAa;AACf;;AAEA;EACE,eAAe;EACf,MAAM;EACN,WAAW;EACX,2CAA2C,EAAE,wBAAwB;EACrE,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".bg-light{\n  background-color: rgb(255 255 255) !important;\n }\n\n.navbar-brand img {\n  width: 150px;\n  height: auto;\n  margin: auto;\n}\n\n.search-form-container {\n  position: relative; /* For positioning the search overlay relative to this container */\n}\n\n.search-button {\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 10px;\n  font-size: 20px;\n}\n\n.search-overlay {\n  position: absolute;\n  top: 0;\n  right: 47px;\n  padding: 0;\n  border-radius: 5px;\n  display: flex\n;\n  align-items: center;\n  z-index: 1000;\n}\n\n.search-input {\n  background-color: #fff;\n  color: #000;\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  padding: 8px;\n  width: 500px;\n  transition: width 0.3s ease;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: #007bff;\n}\n\n.search-overlay .search-input {\n  width: 500px; \n}\n\n.search-overlay.show {\n  opacity: 1;\n  visibility: visible;\n}\n\n\n.nav-link {\n  color: #000!important;\n}\n\n.search-button,\nbutton {\n  border: none;\n  background: none;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 10px 0;\n  margin-left: 10px;\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n}\n\n.dropdown-item {\n  color: black;\n  font-size: 12px;\n  font-weight: bold; /* Makes the font bold */\n  padding: 8px 8px;\n}\n\n.dropdown-item:hover {\n  background: lightgray; /* Changes background color on hover */\n  color: blue; /* Changes text color on hover */\n  cursor: pointer; /* Shows a pointer cursor on hover */\n}\n\n.search-button svg {\n  color: #7f7f7f;\n  font-size: 16px;\n}\n\nbutton a {\n  text-decoration: none;\n  color: #000;\n  display: flex;\n  align-items: center;\n}\n\nbutton a svg {\n  margin-right: 5px;\n}\n\nbutton:hover a {\n  color: white;\n  text-decoration: none;\n\n}\n\n.navbar-nav {\n  font-weight: 600;\n  font-size: 12px;\n  gap: 0;\n}\n\nbutton {\n  border: 1px solid #2067d1;\n  border-radius: 10px;\n  background-color: #2067d1;\n  color: #fff;\n  padding: 8px 12px;\n  transition: all 0.3s ease;\n}\n\n.phoneButton{\n  border-radius: 10px;\n}\n\nbutton a {\n  color: #fff;\n  font-weight: 600;\n}\n\n@media (width <= 768px) {\n  .phoneButton{\n    display: none;\n  }\n\n  .search-overlay{\n    right: 14px;\n  }\n\n  .search-overlay .search-input {\n    width: 336px;\n}\n\n  .navbar {\n    padding: 0.5rem;\n  }\n\n  .logo-img {\n    height: 40px;\n  }\n\n  .nav-link {\n    font-size: 14px;\n    margin-right: 10px;\n    padding: 11px 5px !important;\n    border-bottom: 1px solid #c5c5c5;\n\n  }\n\n  .search-form-container{\n  position: relative;\n    border-bottom: 1px solid #c5c5c5;\n  }\n\n  button {\n    font-size: 12px;\n    padding: 5px 8px;\n    width: 50px;\n\n  }\n\n  button a {\n    font-size: 12px;\n  }\n}\n.ms-auto {\n  margin-left: 28px !important;\n}\n\n.custom-navbar {\n  transition: all 0.3s ease-in-out;\n  width: 100%;\n  z-index: 1000;\n}\n\n.custom-navbar.sticky {\n  position: fixed;\n  top: 0;\n  width: 100%;\n  background-color: rgba(255, 255, 255, 0.95); /* Slight transparency */\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.logo-img {\n  max-height: 60px;\n}\n\n/* Search Box */\n.search-form-container {\n  position: relative;\n}\n\n.search-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 18px;\n}\n\n.search-overlay {\n  position: absolute;\n  right: 0;\n  top: 40px;\n  background: white;\n  border-radius: 5px;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n  padding: 10px;\n}\n\n.search-input {\n  width: 200px;\n  padding: 5px;\n}\n\n/* Phone Button */\n.phoneButton {\n  background-color: #007bff;\n  border: none;\n  padding: 8px 15px;\n  border-radius: 5px;\n  color: white;\n  font-size: 14px;\n  cursor: pointer;\n  margin-left: 10px;\n}\n\n.phoneButton a {\n  color: white;\n  text-decoration: none;\n}\n\n.phoneButton:hover {\n  background-color: #0056b3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
